module.exports = __webpack_public_path__ + "5f107b3a9473d18e9672c8aa80de7c98.png";